// extracted by mini-css-extract-plugin
module.exports = {"switcher":"Switch_switcher__2fCvZ","label":"Switch_label__2QbSt","right":"Switch_right__2uXwl","container":"Switch_container__YVBGY"};